import React, { useEffect, useState } from 'react';
import "../styles/strategies.css";
import "../styles/modal.css";
import StrategiesCardComponent from '../components/Strategies_card_component';
import StrategiesInfo from '../components/InfoModals/StrategiesInfo';

export default function Strategies({ addToast }) {
    const [strategies, setStrategies] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [editId, setEditId] = useState(null);

    const [loggedIn, setLoggedIn] = useState(false);

    const [showInfo, setShowInfo] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    //TITLE, META TAG
    useEffect(() => {
        document.title = "Személyre szabott tippmix stratégiák – Tudatos fogadás, részletes statisztikák | FociFanatik";

        const meta = document.querySelector("meta[name='description']");
        if (meta) {
            meta.setAttribute(
                "description",
                "Bevált tippmix stratégiák és módszerek. Építs hosszú távon nyereséges rendszert adatok és statisztikák alapján."
            );
        }
    }, []);



    // BEVAN E JELETKEZVE
    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setLoggedIn(data.loggedIn);
            });
    }, []);


    const handleSave = () => {
        if (!name || !description) {
            addToast("Kérlek tölts ki minden mezőt!", "warning")
            return;
        }

        const url = editId
            ? `https://focifanatik.hu/api/update_strategy.php?id=${editId}`
            : `https://focifanatik.hu/api/add_strategy.php`;


        fetch(url, {
            method: editId ? "PUT" : "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                name: name,
                description: description
            }),
            credentials: "include"
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    addToast(editId ? "Stratégia frissitve!" : "Stratégia mentve!", "success");
                    setShowModal(false);
                    setName("");
                    setDescription("");
                    setEditId(null)

                    // Újratöltjük a strategiakat, hogy megjelenjen az új is
                    fetch("https://focifanatik.hu/api/strategies.php")
                        .then((r) => r.json())
                        .then((d) => setStrategies(d));
                } else {
                    addToast("Hiba", "warning");
                }
            })
            .catch((err) => addToast("Hálózati hiba!", "warning"));
    };


    //Stratégiák lekérése
    useEffect(() => {
        // FONTOS: pontos URL
        fetch("https://focifanatik.hu/api/strategies.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
                setStrategies(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    // Stratégia törlése
    const handleDelete = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    }

    const confirmDelete = () => {
        fetch(`https://focifanatik.hu/api/delete_strategy.php?id=${deleteId}`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Stratégia törölve!", "success");
                    setStrategies(prev => prev.filter(s => s.id !== deleteId));
                } else {
                    addToast(data.error || "Hiba történt!", "warning");
                }
            })
            .catch(() => addToast("Hálózati hiba!", "warning"))
            .finally(() => {
                setShowDeleteModal(false);
                setDeleteId(null);
            });
    };

    // Stratégia szerkesztése
    const handleEdit = (id) => {
        const selected = strategies.find(s => s.id === id);
        if (!selected) return;

        setEditId(id);
        setName(selected.name);
        setDescription(selected.description);
        setShowModal(true);
    }


    const handleOpenModal = () => {
        if (!loggedIn) {
            window.location.href = "/regisztracio";
            return;
        }

        setEditId(null);
        setName("");
        setDescription("");
        setShowModal(true);
    };
    const handleCloseModal = () => setShowModal(false)

    return (
        <div className="strategies-bg">
            <div className="strategies-page">
                <div className='strategies-header'>

                    <button
                        className="btn-info-strategies"
                        onClick={() => setShowInfo(true)}
                    >
                        <i class="bi bi-info-lg"></i>
                    </button>

                    <div className="d-flex justify-content-center mt-3">
                        <button
                            type="button"
                            className="btn btn-success btn-lg shadow-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 new-strategy-btn"
                            onClick={handleOpenModal}
                        >
                            <span className="btn-icon"></span>
                            {loggedIn ? "Új stratégia létrehozása" : "Regisztráció a stratégiákhoz"}
                        </button>
                    </div>


                </div>



                <div className="strategies-content container mt-5">
                    {/* Ha nincs adat */}
                    {strategies.length === 0 ? (
                        <div className="empty-state text-center mt-5">
                            <div className="empty-icon mb-3">
                                <i class="bi bi-lightbulb fs-1"></i>
                            </div>

                            <h5 className="fw-semibold">Még nincs egyetlen stratégia sem</h5>

                            <p className="text-muted mt-2">
                                Itt fognak megjelenni a saját tippmix stratégiáid.
                                Hozz létre egyet, hogy hosszú távon elemezhesd az eredményeidet.
                            </p>
                        </div>
                    ) : (
                        <div className="row mt-4">
                            {strategies.map((s) => (
                                <StrategiesCardComponent key={s.id} onDelete={handleDelete} onEdit={handleEdit} id={s.id} name={s.name} description={s.description} hit_rate={s.hit_rate} avg_odds={s.avg_odds} />
                            ))}
                        </div>
                    )}
                </div>


                {showInfo && <StrategiesInfo onClose={() => setShowInfo(false)} />}



                {showModal && (
                    <>
                        {/* Sötét háttér */}
                        <div className="custom-modal-backdrop"></div>

                        <div className="custom-modal d-flex justify-content-center align-items-center">
                            <div className="custom-modal-content">

                                {/* CÍM */}
                                <div className="custom-modal-header">
                                    <h5 className="modal-title-custom">
                                        {editId ? "Stratégia szerkesztése" : "Új stratégia"}

                                    </h5>
                                    <button className="close-btn" onClick={handleCloseModal}>×</button>
                                </div>


                                {/* TARTALOM */}
                                <div className="custom-modal-body">
                                    <form>
                                        <div className="mb-3">
                                            <label className="form-label">Név</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder="Írd ide a nevét, pl: Döntetlenes stratégia"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Leírás</label>
                                            <textarea
                                                className="form-control"
                                                rows="8"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                placeholder="Írd ide a megjegyzésed, pl: Csak döntetlenekre fogadok."
                                            ></textarea>
                                        </div>
                                    </form>

                                </div>

                                {/* LÁB */}
                                <div className="custom-modal-footer">
                                    <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                                        Mégse
                                    </button>
                                    <button className="pretty-btn save-btn" onClick={handleSave}>
                                        Mentés
                                    </button>
                                </div>


                            </div>
                        </div>
                    </>
                )}
                {showDeleteModal && (
                    <>
                        <div className="custom-modal-backdrop"></div>

                        <div className="custom-modal d-flex justify-content-center align-items-center">
                            <div className="custom-modal-content small-modal">

                                <div className="custom-modal-header">
                                    <h5 className="modal-title-custom">
                                        Biztos törlöd?
                                    </h5>
                                    <button
                                        className="close-btn"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        ×
                                    </button>
                                </div>

                                <div className="custom-modal-body text-center">
                                    <p>Ez a művelet nem visszavonható.</p>
                                </div>

                                <div className="custom-modal-footer">
                                    <button
                                        className="pretty-btn cancel-btn"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        Mégse
                                    </button>
                                    <button
                                        className="pretty-btn danger-btn"
                                        onClick={confirmDelete}
                                    >
                                        Törlés
                                    </button>
                                </div>

                            </div>
                        </div>
                    </>
                )}

            </div>
        </div>
    );
}
